import { Route, Routes } from 'react-router-dom'
import LogoutPage from '../auth/LogoutPage'
import ListAllUsersPage from '../users/ListAllUsersPage'
import UserFormPage from '../users/UserFormPage'
import HomePage from '../home/HomePage'

export default function Body (props = {}) {
  return (
    <div className="content-wrapper">
      <section className="content body">
        <div className="row">
          <Routes>
            <Route exact={false} path="/" element={ <HomePage />}/>      
            <Route exact={true} path="/users/list" element ={ <ListAllUsersPage /> } />
            <Route exact={true} path="/users/edit/:koId" element ={ <UserFormPage /> } /> 
            <Route exact={true} path="/logout" element = { <LogoutPage />} />
            {/* <Route exact={true} path="/bu-assessments/quality-and-food-safety-assessments/edit/:id" element ={ <QualityAndFSAssessmentFormPage /> } />
            <Route exact={true} path="/bu-assessments/environmental-and-safety-assessments/edit/:id" element ={ <EnvironmentalAndSafetyAssessmentFormPage /> } /> */}
            {/* <Route exact={true} path="/bu-assessments/self-assessments" element ={ <ListSelfAssessmentsPage /> } /> */}
            {/* <Route exact={true} path="/bu-assessments/quality-and-food-safety-assessments" element ={ <ListQualityAndFSAssessmentsPage /> } /> */}
            {/* <Route exact={true} path="/bu-assessments/environmental-and-safety-assessments" element ={ <ListEnvironmentalAndSafetyAssessmentsPage /> } /> */}
          </Routes>
        </div>
      </section>
    </div>
  )
}
